/**
 * ProductCompare Component
 * Optimized for SPA-like DOM replacements via Web Component Lifecycles
 */
if (!customElements.get('product-compare')) {
  class ProductCompare extends HTMLElement {
    constructor() {
      super();
      // Bind the handler to maintain context and allow removal later
      this.handleToggle = this.handleToggle.bind(this);
    }

    /**
     * Fires when the component is inserted into the DOM.
     * Perfect for re-initializing after Boost replaces the view.
     */
    connectedCallback() {
      this.compareToggle = document.getElementById('compare-switch');
      
      if (this.compareToggle) {
        // 1. Bind Event Listener
        this.compareToggle.addEventListener('change', this.handleToggle);

        // 2. Initialize State from Storage
        const storedState = theme.storageUtil.get('compare-toggle');
        const isChecked = storedState !== null ? storedState : this.compareToggle.checked;

        // Apply state immediately
        this.toggleCompare(null, isChecked, true);

        // 3. Visual Readiness
        setTimeout(() => {
          this.classList.add('transition-ready');
          const grid = this.getGrid();
          if (grid) grid.classList.add('transition-ready');
        }, 500);
      }
    }

    /**
     * Fires when the component is removed from the DOM.
     * Crucial for preventing memory leaks during Boost re-renders.
     */
    disconnectedCallback() {
      if (this.compareToggle) {
        this.compareToggle.removeEventListener('change', this.handleToggle);
      }
    }

    /**
     * Always fetch the freshest grid element.
     */
    getGrid() {
      return document.querySelector('.boost-sd__filter-product-list');
    }

    /**
     * Wrapper for the event listener
     */
    handleToggle(evt) {
      this.toggleCompare(evt);
    }

    /**
     * Logic to handle the toggle state and resource injection
     */
    toggleCompare(evt, checked = null, persist = true) {
      const isChecked = evt ? evt.target.checked : checked;
      const grid = this.getGrid();

      // Update Grid Data Attribute 
      if (grid) {
        grid.dataset.compare = isChecked;
      }

      // Handle the Compare Drawer/Button
      const compareButton = document.getElementById('compare-drawer-open');
      if (compareButton) {
        compareButton.classList.toggle('is-out', !isChecked);
      }

      // Sync the toggle UI if updated programmatically
      if (!evt && this.compareToggle) {
        this.compareToggle.checked = isChecked;
      }

      // Save preference
      if (persist && !window.Shopify?.designMode) {
        theme.storageUtil.set('compare-toggle', isChecked);
      }

      // Inject JS/CSS if Compare is turned ON
      if (isChecked) {
        this.loadResources();
      }
    }

    loadResources() {
      const resourcesTag = document.getElementById('compare-resources');
      if (!resourcesTag) return;

      try {
        const resources = JSON.parse(resourcesTag.textContent);
        resources.forEach((resource) => {
          const isJS = resource.type === 'js';
          const selector = isJS ? `script[src="${resource.path}"]` : `link[href="${resource.path}"]`;
          
          if (!document.querySelector(selector)) {
            const el = document.createElement(isJS ? 'script' : 'link');
            if (isJS) {
              el.src = resource.path;
              el.async = true;
            } else {
              el.href = resource.path;
              el.rel = 'stylesheet';
            }
            document.head.appendChild(el);
          }
        });
        resourcesTag.remove(); // Clean up after loading
      } catch (error) {
        console.error("Product Compare: Resource load failed", error);
      }
    }
  }

  customElements.define('product-compare', ProductCompare);
}